module.exports = __webpack_public_path__ + "static/media/check-box-empty.00072baf.svg";